import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../shared/services/commen/commen.services';
import { OrdersService } from '../../../shared/services/orders/orders.service';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-new-shipment-page',
  templateUrl: './new-shipment-page.component.html',
  styleUrls: ['./new-shipment-page.component.scss']
})
export class NewShipmentPageComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  isFormSubmit: boolean = false;
  TenantId: any;
  CompanyId: any;
  userId: any;
  data: any = {};
  @Input() bookingData: any;
  @Input() IsSaveDisable: any = false;
  @Output() onSave = new EventEmitter<any>();
  TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'TransportService',
    dataField: 'TransportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Transporter: any = {
    lable: 'Transporter',
    formControlName: 'Transporter',
    dataField: 'Transporter',
    isRequired: true,
    placeholder: 'Select Transporter',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleType',
    dataField: 'VehicleType',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleNo: any = {
    lable: 'VehicleNo',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: true,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  DriverMobileNo = {
    lable: 'Driver Mobile No',
    formControlName: 'DriverMobileNo',
    dataField: 'DriverMobileNo',
    isRequired: true,
    placeholder: 'Enter Driver Mobile No',
  };
  VehiclePlacementDate = {
    lable: 'Vehicle Placement Date',
    formControlName: 'VehiclePlacementDate',
    dataField: 'VehiclePlacementDate',
    isRequired: true,
    placeholder: 'Select Vehicle Placement Date',
  };
  LeadTime = {
    lable: 'Lead Time in Days',
    formControlName: 'LeadTime',
    dataField: 'LeadTime',
    isRequired: false,
    placeholder: 'Enter Lead Time in Days',
    type: 'number'
  };
  EstimatedDeliveryDate = {
    lable: 'Estimated Delivery Date',
    formControlName: 'EstimatedDeliveryDate',
    dataField: 'EstimatedDeliveryDate',
    isRequired: true,
    placeholder: 'Select Estimated Delivery Date',
  };
  Advance = {
    lable: 'Advance',
    formControlName: 'Advance',
    dataField: 'Advance',
    isRequired: false,
    placeholder: 'Enter Advance',
    type: 'number'
  };

  isMobileView: any;

  constructor(
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private anghttp: Http,
    private commonService: CommonService,
    private decryptpipe: DecryptPipe,
    private service: TranslateConfigService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private router: Router,
    private dp: DatePipe
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.getDropdownList(null, this.TransportService);
    this.getDropdownList('%%', this.VehicleType);
    this.data = this.bookingData;
    if (this.bookingData.VehicleNo) {
      this.GetVehicleNoList(this.bookingData.VehicleNo, false);
    }
    if (this.bookingData.Driver !== '' || this.bookingData.Driver !== null) {
      const DriverName = decodeURIComponent(this.bookingData.DriverName); // Decode Driver
      const DriverCode = decodeURIComponent(this.bookingData.DriverCode);
      if (this.bookingData.DriverCode) {
        this.GetDriverList(this.bookingData.DriverCode, false)
      } else {
        this.GetDriverList(this.bookingData.DriverName, false)
      }
    } else {
      console.log('calling')
      this.Driver.placeholder = 'Select Driver'
    }
    console.log('details', this.data, this.bookingData)
    this.data.Transporter = this.bookingData.Transporter.toLowerCase();
    this.GetTransporterList(this.data.TransporterName, false);
  }

  close() {
    this.onCloseEvent.emit();
  }

  getChangedValue(value, data) {
    if (data.dataField == 'Transporter') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'VehicleNo') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'Driver') {
      this.data[data.dataField] = value.value;
      this.data.DriverMobileNo = value.MobileNo;
    } else if (data.dataField == 'LeadTime') {
      this.data[data.dataField] = value;

      const result = new Date(this.data.VehiclePlacementDate);
      result.setDate(result.getDate() + parseInt(value));
      this.data.EstimatedDeliveryDate = this.dp.transform(result, 'dd-MMM-yyyy');
    } else {
      this.data[data.dataField] = value;
    }
  }

  getDropdownList(value, data) {
    if (data.dataField === 'TransportService') {
      this.searchStatusOnField(data, true);
      this.orderService.GetTransportServiceList().then(res => {
        this.findObjectOfTheFieldV2(this.TransportService, res);
      }).catch(error => {
        this.searchStatusOnField(data, false);
      })
    }
    if (data.dataField === 'VehicleType') {

      this.searchStatusOnField(data, true);
      this.orderService.GetVehicleTypeselect2(value, 1).then(res => {
        this.findObjectOfTheFieldV2(this.VehicleType, res);
      }).catch(error => {
        this.searchStatusOnField(data, false);
      })
    }
  }

  findObjectOfTheFieldV2(data, dropdownList) {
    data.dropdownList = dropdownList;
    data.isSearch = false;
    if (data.dataField) {
      data.isReadOnly = false
    }
  }

  searchStatusOnField(data, Status) {
    data.isSearch = Status;
  }

  GetTransporterList(value, isScrollDown = false) {
    this.Transporter.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Transporter.dropdownList.length / 20) + 1;
    }
    this.orderService.TransporterSelect2(value, pageNo, this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Transporter.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Transporter.dropdownList);
        this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] });
      this.Transporter.isSearch = false;
    }).catch(error => {
      this.Transporter.isSearch = false;
    })
  }

  GetVehicleNoList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 40) + 1;
    }
    this.orderService.GetBookingVehicleNoSelect2(value, pageNo, this.data.Transporter, this.data.VehicleType).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 40) + 1;
    }
    this.orderService.GetDriverSelect2(value, pageNo, this.data.Transporter).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  ValidateData() {
    var IsAllDataDone: any = true;
    if (!this.data.TransportService) {
      IsAllDataDone = false;
    }
    if (!this.data.Transporter) {
      IsAllDataDone = false;
    }
    if (!this.data.VehicleType) {
      IsAllDataDone = false;
    }
    if (!this.data.VehicleNo) {
      IsAllDataDone = false;
    }
    if (!this.data.Driver) {
      IsAllDataDone = false;
    }
    if (!this.data.DriverMobileNo) {
      IsAllDataDone = false;
    }
    if (!this.data.EstimatedDeliveryDate) {
      IsAllDataDone = false;
    }
    if (!this.data.VehiclePlacementDate) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  OnSaveAssignVehicle() {
    this.isFormSubmit = true;
    if (this.ValidateData()) {
      this.onSave.emit(this.data);
    }
  }


}
